import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Control } from "react-hook-form";
import { FormRadioGroup, HeaderDivider } from "components";
import { CandidateDetailsFormData } from "../validation";

export const InformationNotes = ({
  control,
}: {
  control: Control<CandidateDetailsFormData>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider text={t("details.informationNotesTitle")} sx={{ mb: 3 }} />
      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {t("details.privacyNote.title")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          {t("details.privacyNote.text")}
        </Typography>

        <Typography variant="h5" sx={{ mb: 2 }}>
          {t("details.dataProtection.title")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          {t("details.dataProtection.text")}
        </Typography>

        <Typography variant="h5" sx={{ mb: 2 }}>
          {t("details.marketingConsent.title")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          {t("details.marketingConsent.text")}
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            {t("details.marketingConsent.label")}:
          </Typography>
          <FormRadioGroup
            name="marketingConsent"
            control={control}
            options={[
              { value: true, name: t("details.marketingConsent.yes") },
              { value: false, name: t("details.marketingConsent.no") },
            ]}
          />
        </Box>
      </Box>
    </>
  );
};
